
import { useDispatch, useSelector } from "react-redux";
import { 
    Container, 
    Typography, 
    Link,
    Grid,
    Box,
    Paper
} from "@mui/material";

import Checkbox from '@/components/ph/Checkbox';

import { setTermAcceptance } from '../quoteSlice';

const TermsAndConditions = () => {

    const dispatch = useDispatch();
    const termsState = useSelector((state) => state.quote.termsAndConditions);

    const handlePrivacyChange = (e) => {
        dispatch(setTermAcceptance({ 
        term: 'privacyNotice', 
        accepted: e.target.checked 
        }));
    };

    const handleTermsChange = (e) => {
        dispatch(setTermAcceptance({ 
        term: 'termsAndConditions', 
        accepted: e.target.checked 
        }));
    };


  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
        <Paper elevation={0} sx={{ p: { md: 2 }, mb: { xs: 2, md: 2 } }}>
            <Grid container spacing={2} size={{ xs: 12, md: 12 }}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                        <Checkbox
                            checked={termsState.privacyNotice}
                            onChange={handlePrivacyChange}  
                            label={
                                <Typography variant="body2" component="span"
                                    sx={{ textTransform: 'none' }}>
                                He leído y acepto los Avisos de Privacidad de{" "}
                                <Link href="https://www.elpalaciodehierro.com/aviso-privacidad.html" target="_blank" underline="auto" fontWeight="regular"
                                    sx={{ textTransform: 'none', color: "rgba(0, 0, 0, 0.87)" }}>
                                    El Palacio de Hierro
                                </Link>{" "}
                                y{" "}
                                <Link href="https://www.gnp.com.mx/aviso-de-privacidad/integral" target="_blank" underline="auto" fontWeight="regular"
                                    sx={{ textTransform: 'none', color: "rgba(0, 0, 0, 0.87)" }}>
                                    GNP
                                </Link>{""}
                                *
                                </Typography>
                            }
                        />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                        <Checkbox
                            checked={termsState.termsAndConditions}
                            onChange={handleTermsChange}
                            label={
                                <Typography variant="body2" component="span"
                                    sx={{ textTransform: 'none' }}>
                                He leído y acepto los Términos y Condiciones de{" "}
                                <Link href="https://www.elpalaciodehierro.com/terminos-condiciones.html" target="_blank" underline="auto" fontWeight="regular"
                                    sx={{ textTransform: 'none', color: "rgba(0, 0, 0, 0.87)" }}>
                                    El Palacio de Hierro
                                </Link>{" "}
                                y{" "}
                                <Link href="https://www.gnp.com.mx/uso-de-medios-electronicos" target="_blank" underline="auto" fontWeight="regular"
                                    sx={{ textTransform: 'none', color: "rgba(0, 0, 0, 0.87)" }}>
                                    GNP
                                </Link>{""}
                                *
                                </Typography>
                            }
                        />
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    </Container>
  );
};

export default TermsAndConditions